import React, { useEffect, useRef, useState } from 'react';
import { HubspotBrochureDownload } from ".";
import "../../styles/demo-req-page.css";
import { globalHistory } from "@reach/router"
import {Trans, useTranslation} from 'gatsby-plugin-react-i18next'
import LazyLoad from "react-lazy-load";

const RequestDemo = (props) => {
    const path = globalHistory.location.pathname;
    const { t } = useTranslation();
    const videoRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // Stop observing once the video is in view
                }
            },
            {
                threshold: 0.5, // Load the video when 50% of it is in view
            }
        );

        if (videoRef.current) {
            observer.observe(videoRef.current);
        }

        return () => {
            if (videoRef.current) {
                observer.disconnect();
            }
        };
    }, []);

    return (
    <div>
        <section className="w-100">
            <div>
                <div className="row">
                    <div className="col-md-6 col-sm-12 demo-page-bg">
                        <div className="container">
                            <div className="padding-dem">
                                <div>
                                    <a className="navbar-brand pt-3" href={t(`/`)}>
                                        <img
                                            width="220"
                                            height="45"
                                            className="site-logo"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                                            alt="Vantage Fit - A Complete Solution To Your Corporate Wellness Program"
                                        />
                                    </a>
                                </div>
                                <div className="pt-5 pb-3">
                                    <h1 className="font-weight-semibold py-2 section-heading text-white">
                                        <Trans>Schedule a <br/>Vantage Fit Demo</Trans>
                                    </h1>
                                </div>
                                <div>
                                    <p
                                        className="section-para font-weight-normal aos-init aos-animate text-white text-center text-lg-left"
                                        data-aos="fade-right"
                                        data-aos-once="true"
                                    >
                                        <Trans>Explore a new era of team health with
                                        our corporate wellness platform,
                                        tailored to enhance employee well-being!</Trans>
                                    </p>
                                </div>
                                <div className="demo-pageform">
                                    {/* <Lazyload>
                                        <HubspotBrochureDownload formID="c169c509-7422-4098-bdd2-085a67d82092" />
                                    </Lazyload> */}
                                    {(path === `/fr/planifier-demo/`  || path === `/fr/planifier-demo`  ?
							            <HubspotBrochureDownload formID="da747fb4-639f-4112-b663-eddd3a3c41aa"/> :
                                        (path === `/es/solicita-una-demo/`  || path === `/es/solicita-una-demo` ?  <HubspotBrochureDownload formID="b44a17e4-1957-4d05-bdc7-21a260effd61"/>:  (path === `/de/demo-anfordern/`  || path === `/de/demo-anfordern` ?  <HubspotBrochureDownload formID="62a6fa0f-83cc-436b-bf45-ebcd06a3eb50"/> :
                                        <HubspotBrochureDownload formID="c169c509-7422-4098-bdd2-085a67d82092"/>
                                    )))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 demo-page-bg2 dm-align-center padd-y-5">
                        <div className="container">
                            {path === `/fr/planifier-demo/` ? (
                                <>
                                    <div className="d-flex justify-content-center">
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709879511/VantageFit/2023/french/vfit-french-combo.png" alt="Vantage Fit Video" width="600" height="497" decoding="async" loading="lazy"/>
                                    </div>
                                </>
                            ) : (
                                <div ref={videoRef}
                                    className="w-100 d-flex justify-content-center"
                                    style={{ height: "fit-content" }}
                                >
                                    {isVisible && (
                                        <video
                                            autoPlay
                                            loop
                                            muted
                                            playsInline
                                            width="100%"
                                            height="auto"
                                            style={{
                                                borderRadius: "10px",
                                                maxWidth: "600px",
                                                border: "2px solid white",
                                                objectFit: "cover",
                                            }}
                                            preload="auto"
                                            controls={false}
                                            aria-label="Background video showing VantageFit feature"
                                        >
                                            <source
                                                type="video/webm"
                                                src="https://res.cloudinary.com/vantagecircle/video/upload/v1704800863/VantageFit/2023/Vfit_Feature_1_copy.webm"
                                            />
                                            <source
                                                type="video/mp4"
                                                src="https://res.cloudinary.com/vantagecircle/video/upload/v1704800863/VantageFit/2023/Vfit_Feature_1_copy.mp4"
                                            />
                                            Your browser does not support the video tag.
                                        </video>
                                    )}

                                </div>
                            )}

                        </div>
                        <div
                            className="container"
                            style={{ maxWidth: "600px", marginTop: "2rem" }}
                        >
                            <p className="text-white text-center" style={{fontSize:'1.3rem'}}><Trans i18nKey="substext4">Trusted by <span className="orange-font font-weight-bold">100+ </span>organizations</Trans></p>
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2  border bg-light  d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/First-source-logo.webp"
                                            width="115"
                                            height="46"
                                            alt="firstSource"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2  border bg-light d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/MI-logo.webp"
                                            width="47"
                                            height="46"
                                            alt="MI"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2 border bg-light  d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/accenture-logo.webp"
                                            width="140"
                                            height="46"
                                            alt="accenture"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2  border bg-light  d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/ESAF-logo.webp"
                                            width="120"
                                            height="46"
                                            alt="ESAF"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2  border bg-light d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/citi-logo.webp"
                                            width="71"
                                            height="46"
                                            alt="citi"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-6 p-0">
                                    <div
                                        className="p-3 m-2 border bg-light  d-flex justify-content-center "
                                        style={{
                                            height: "5rem",
                                            borderRadius: "0.7rem",
                                        }}
                                    >
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592770/VantageFit/2023/Bajaj-logo.webp"
                                            width="140"
                                            height="46"
                                            alt="Bajaj"
                                            style={{
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center align-items-center mx-auto py-5 flex-wrap">
                <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                    <LazyLoad>
                        <img
                            loading="lazy"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592948/VantageFit/2023/Leader_Enterprise_Gobal.webp"
                            alt="G2 award4"
                            width="129"
                            height="146"
                        />
                    </LazyLoad>
                </div>
                <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                    <LazyLoad>
                        <img
                            loading="lazy"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592948/VantageFit/2023/Brandon_Hall_Group.webp"
                            alt="Brandon hall award"
                            width="189"
                            height="146"
                        />
                    </LazyLoad>
                </div>
                <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                    <LazyLoad>
                        <img
                            decoding="async"
                            loading="lazy"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592948/VantageFit/2023/Bakers-Dozen.webp"
                            alt="Baker's Dozen award"
                            width="160"
                            height="146"
                        />
                    </LazyLoad>
                </div>
                <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                    <LazyLoad>
                        <img
                            decoding="async"
                            loading="lazy"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592947/VantageFit/2023/best-of-relationship-winter-2023-gradient.webp"
                            alt="relationship winter 2023"
                            width="129"
                            height="146"
                        />
                    </LazyLoad>
                </div>
                <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
                    <LazyLoad>
                        <img
                            decoding="async"
                            className=""
                            loading="lazy"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1703592947/VantageFit/2023/crozdesk-happiest-users-badge.webp"
                            alt="crozdesk-happiest-users-badge"
                            width="149"
                            height="146"
                        />
                    </LazyLoad>
                </div>
            </div>
        </section>
    </div>
    );
}

export default RequestDemo;
